type ImageFormat = 'square' | 'landscape' | 'portrait' | 'wide' | 'tall';

export function getFormat(imgEl: HTMLImageElement): ImageFormat {
	const componentEl = imgEl.closest('[data-component="picture"]');
	if (componentEl) {
		if (componentEl.classList.contains('picture--ratio-1-1')) {
			return 'square';
		}
	}

	return getFormatFromDimensions(imgEl.width, imgEl.height);
}

export function getFormatFromDimensions(width: number, height: number) {
	const appliedAspectRatio = width / height;

	if (appliedAspectRatio > 2) {
		return 'wide';
	}

	if (appliedAspectRatio > 1.2) {
		return 'landscape';
	}

	if (appliedAspectRatio < 0.5) {
		return 'tall';
	}

	if (appliedAspectRatio < 0.8) {
		return 'portrait';
	}

	return 'square';
}
